import "./masterButton.css";
export enum ButtonLayoutType {
  Icon,
  IconLabel,
  Label,
  LabelIcon,
  IconLabelVertical,
}

export enum ButtonSize {
  Large,
  Medium,
  Small,
  XS,
}

export enum ButtonVariation {
  PrimaryFilled,
  SecondaryFilled,
  PrimaryTonal,
  Outlined,
  Clean,
  NeutralTonal,
  ErrorTonal,
}

type MasterButtonProps = {
  options: {
    layoutType: ButtonLayoutType;
    size: ButtonSize;
    variation: ButtonVariation;
    label: string;
    icon: string | JSX.Element;
    className?: string;
    ref?: HTMLButtonElement | undefined;
  };
  disabled?: boolean;
  onClick: () => void;
};

const MasterButton: React.FC<MasterButtonProps> = ({ options, disabled, onClick }) => {
  function getLabelClassName(): string {
    switch (options.size) {
      case ButtonSize.Large:
        return "button-label label-large";
      case ButtonSize.Medium:
        return "button-label label-medium";
      case ButtonSize.Small:
        return "button-label label-small";
      default:
        return "button-label";
    }
  }

  function getContentClassName(): string {
    var mainClassName = "content";

    if (options.layoutType === ButtonLayoutType.LabelIcon) {
      mainClassName += " label-icon";
    } else if (options.layoutType === ButtonLayoutType.IconLabelVertical) {
      mainClassName += " vertical";
    }

    switch (options.variation) {
      case ButtonVariation.PrimaryFilled:
        return mainClassName + " primary";
      case ButtonVariation.SecondaryFilled:
        return mainClassName + " secondary";
      case ButtonVariation.PrimaryTonal:
        return mainClassName + " primary-tonal";
      case ButtonVariation.NeutralTonal:
        return mainClassName + " neutral-tonal";
      case ButtonVariation.Outlined:
        return mainClassName + " outlined";
      case ButtonVariation.Clean:
        return mainClassName + " clean";
      case ButtonVariation.ErrorTonal:
        return mainClassName + " error-tonal";

      default:
        return "content";
    }
  }

  function getMainClassName(): string {
    var className = options.className ?? "";
    switch (options.size) {
      case ButtonSize.Large:
        return className + " master-button large";
      case ButtonSize.Medium:
        return className + " master-button medium";
      case ButtonSize.Small:
        return className + " master-button small";
      case ButtonSize.XS:
        return className + " master-button xs";
      default:
        return className + " master-button";
    }
  }

  return (
    <button
      disabled={disabled}
      className={getMainClassName()}
      onClick={() => {
        onClick();
      }}
    >
      <div className="overlay"></div>
      <div className={getContentClassName()}>
        {options.layoutType !== ButtonLayoutType.Label &&
          (typeof options.icon === "string" ? <img alt={options.label + " Button Icon"} src={options.icon} className="icon"></img> : <div className="icon"> {options.icon}</div>)}
        {options.layoutType !== ButtonLayoutType.Icon && <div className={getLabelClassName()}>{options.label}</div>}
      </div>
    </button>
  );
};

export default MasterButton;
